import React from 'react';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import Icon from 'qwc2/components/Icon';
import LocaleUtils from 'qwc2/utils/LocaleUtils';
import {pushView, stepView} from '../actions/viewhistory';
import '../style/MapViewHistory.css';

// Wait until the map came to rest, view changes are dispatched continuously while panning/zooming
const SETTLE_DELAY_MS = 500;

/**
 * Back/forward buttons to navigate through the previous map views (position and zoom).
 * Always mounted in the top bar, so it also records the views.
 */
class MapViewHistory extends React.Component {
    static propTypes = {
        canGoBack: PropTypes.bool,
        canGoForward: PropTypes.bool,
        map: PropTypes.object,
        mapLoaded: PropTypes.bool,
        pushView: PropTypes.func,
        stepView: PropTypes.func
    }

    constructor(props) {
        super(props);
        this.timer = null;
    }

    componentDidUpdate(prevProps) {
        const {map, mapLoaded} = this.props;
        if (!mapLoaded) {
            return;
        }
        if (!prevProps.mapLoaded || prevProps.map.center !== map.center || prevProps.map.zoom !== map.zoom) {
            clearTimeout(this.timer);
            this.timer = setTimeout(this.record, SETTLE_DELAY_MS);
        }
    }

    componentWillUnmount() {
        clearTimeout(this.timer);
    }

    record = () => {
        this.timer = null;
        this.props.pushView({center: this.props.map.center, zoom: this.props.map.zoom});
    }

    render() {
        const backTitle = LocaleUtils.tr("mapviewhistory.back");
        const forwardTitle = LocaleUtils.tr("mapviewhistory.forward");
        return (
            <div className="MapViewHistory">
                <button disabled={!this.props.canGoBack} onClick={() => this.props.stepView(-1)} title={backTitle}>
                    <Icon icon="chevron-left" />
                </button>
                <button disabled={!this.props.canGoForward} onClick={() => this.props.stepView(1)} title={forwardTitle}>
                    <Icon icon="chevron-right" />
                </button>
            </div>
        );
    }
}

export default connect(state => ({
    canGoBack: state.viewhistory.index > 0,
    canGoForward: state.viewhistory.index < state.viewhistory.entries.length - 1,
    map: state.map,
    mapLoaded: state.layers.flat.length > 0 && !!state.map.size
}), {
    pushView: pushView,
    stepView: stepView
})(MapViewHistory);
